import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <title>Chevron Forward</title>
    <path
      fill="none"
      d="M19.5 14.0833V20.5833C19.5 21.158 19.2717 21.7091 18.8654 22.1154C18.4591 22.5217 17.908 22.75 17.3333 22.75H5.41667C4.84203 22.75 4.29093 22.5217 3.8846 22.1154C3.47827 21.7091 3.25 21.158 3.25 20.5833V8.66667C3.25 8.09203 3.47827 7.54093 3.8846 7.1346C4.29093 6.72827 4.84203 6.5 5.41667 6.5H11.9167M16.25 3.25H22.75M22.75 3.25V9.75M22.75 3.25L10.8333 15.1667"
      stroke="white"
      strokeWidth="1.73333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
export default Icon;
